import React from 'react';

import type {
  LayoutType,
  PlacementId,
  RecommendationCategories
} from '@schibsted-nmp/advertising-shared';

import { RecommendationIds } from '../hooks/RecommendationIds.js';

export function AdvertisingRecircItemPageComponent(
  props: AdvertisingRecircItemPageComponent.Props
) {
  return <AdvertisingRecircItemPageComponent.Forwarded {...props} />;
}

export namespace AdvertisingRecircItemPageComponent {
  export type Props = React.ComponentProps<typeof Forwarded>;

  export const Forwarded = React.forwardRef<HTMLDivElement, Forwarded.Props>(
    ({ itemId, initialLayoutType, categories }, ref) => {
      const recommendationIds = RecommendationIds.use(itemId);

      if (!recommendationIds) return <div />;

      const { placementId, adIndex, containerId, slotId } = recommendationIds;

      return (
        <advt-component
          containerId={containerId}
          initialLayoutType={initialLayoutType}
          categories={categories}
          adIndex={adIndex}
          placementId={placementId}
        >
          <div ref={ref} id={containerId} slot={slotId}></div>
        </advt-component>
      );
    }
  );

  export namespace Forwarded {
    export type Props = {
      /** The id of the item to get the `placementId` for. */
      itemId: PlacementId;

      /** The categories of the item to get the `placementId` for. */
      categories?: RecommendationCategories | undefined;

      /** The initial layout type of the item to get the `placementId` for. (Grid or List) */
      initialLayoutType?: LayoutType | undefined;
    };
  }
}
